<template>
  <div id="users">
    <div class="intro-wrapper">
      <div class="content">
        <h2>{{ $t("settings.users.title") }}</h2>
        <p class="description text-muted">
          {{ $t("settings.users.message") }}
        </p>
        <button class="btn btn-primary-outline" @click="addUser">
          <i class="fa-light fa-plus"></i>
          {{ $t("users.users-add-btn") }}
        </button>
      </div>
    </div>
    <div class="user-list-wrapper">
      <users-list :users="users" :class="{ 'loading-view': loadingUsers }" />
    </div>
  </div>
</template>

<script>
import omit from "lodash/omit";
import UsersList from "@/components/UsersList";
import AddUser from "@/components/modals/AddUser";
import ConfirmModal from "@/components/modals/ConfirmModal";
export default {
  data() {
    return {
      error: false,
      loading: false,
      succes: false,
      loadingUsers: false
    };
  },
  computed: {
    users() {
      return this.$store.state.users;
    }
  },
  methods: {
    addUser() {
      this.$modal.show(
        AddUser,
        {
          allowEmpty: true,
          title: this.$t("users.users-add-btn"),
          onSave: (user) => {
            this.loading = true;
            user = omit(user, "reenteredpassword");
            user = JSON.stringify(user);
            this.$store
              .dispatch("addUser", user)
              .then(() => {
                this.stopLoading();
              })
              .catch((error) => {
                this.error = true;
                this.$modal.show(
                  ConfirmModal,
                  {
                    title: this.$t("confirm-modal.user-error-title"),
                    description: this.$t("confirm-modal.user-error"),
                    confirmButtonText: "Ok",
                    hideCancelButton: true
                  },
                  { width: 310, height: "auto", adaptive: true }
                );

                this.stopLoading();
              });
          }
        },
        { width: 320, height: "auto", adaptive: true }
      );
    },

    stopLoading() {
      this.loading = false;
    }
  },
  mounted() {
    this.loadingUsers = true;
    this.$store
      .dispatch("getUsers")
      .then(() => {})
      .finally(() => {
        this.loadingUsers = false;
      });
  },

  components: {
    UsersList
  }
};
</script>

<style lang="less">
#users {
  // padding: 0 20px;
  padding-top: 103px;
}

@media screen and (min-width: 920px) {
  #users {
    display: grid;
    grid-template-columns: 3fr 7fr;
    gap: 42px;
    justify-content: space-between;

    .user-list-wrapper {
      display: flex;
      justify-content: flex-end;
      flex-grow: 1;
    }
  }
}
</style>
